import * as React from 'react';
import { Button, IconHeartOff16, IconHeartOn16 } from '@cian/ui-kit';
import * as styles from './FavoriteButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FavoriteButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var isFavorite = _ref.isFavorite,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsx(Button, {
      ref: ref,
      onClick: onClick,
      size: "XS",
      beforeIcon: isFavorite ? /*#__PURE__*/_jsx(IconHeartOn16, {}) : /*#__PURE__*/_jsx(IconHeartOff16, {}),
      theme: "fill_secondary",
      children: isFavorite ? 'В избранном' : 'В избранное'
    })
  });
});
FavoriteButton.displayName = 'FavoritesButton';